<template>
  <v-container fluid class="company-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-account`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-heart-box</v-icon>
            Company
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>
          <v-tab-item
            :value="'tab-account'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="left">
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Edit Company</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'companycode')"
                        v-bind:value="initvalue.companycode"
                        placeholder="Company Code"
                        persistent-hint
                        single-line hint="Enter the company code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'companyname')"
                        v-bind:value="initvalue.companyname"
                        placeholder="Company Name"
                        persistent-hint
                        single-line hint="Enter the company name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=companytypes
                        :value="initvalue.companytype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'companytype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the company type">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'companystatus')"
                          v-bind:label="initvalue.companystatus"
                          v-model="initvalue.companystatus"
                          value="Active"
                      ></v-switch>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'companyemail')"
                        v-bind:value="initvalue.companyemail"
                        placeholder="Company Email"
                        persistent-hint
                        single-line hint="Enter the company email">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'finance_email')"
                        v-bind:value="initvalue.finance_email"
                        placeholder="Finance Email"
                        persistent-hint
                        single-line hint="Enter the finance email">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'notify_email')"
                        v-bind:value="initvalue.notify_email"
                        placeholder="Notify Email"
                        persistent-hint
                        single-line hint="Enter the notify email">
                      </v-text-field>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                        <v-btn
                            to="/company/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editCompany()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/company/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPhoto()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import router from '@/Routes';
import {mapActions, mapState} from "vuex";

export default {
  data () {
    return {
      company: {},
      detail: {},
      photo: {},
      filename: null,
      initvalue: {},
      imageurl: undefined,
      images: [],
      upload: {},
      companytypes: ['Distributor', 'Manufacturer', 'Retail', 'Trading', 'Wholesale', 'Other Company'],
    }
  },
  methods: {
    ...mapActions('Company', ['updateCompanyRequest', 'updateCompanyImageRequest', 'updateCompanyPinRequest','getCompaniesRequest']),
    async editCompany() {
      this.company._id = this.initvalue._id;
      await this.updateCompanyRequest(this.company);
      router.push('/company/list');
    },
    editPhoto() {
      this.photo._id = this.initvalue._id;
      this.updateCompanyImageRequest(this.photo);
      this.getCompaniesRequest();
      router.push('/company/list');
    },
    updateChangedValue(value, field){
      this.company[field] = value;
    },
    updateChangedDetail(value, field){
      this.detail[field] = value;
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.photo.companyimage = file;
      this.photo.imagename = file.name;
      this.createImage(file);
    },
    onUploadChange(file) {
      if (!file) {return;}
      this.upload.companyimage = file;
      this.upload.imagename = file.name;
    },
  },
  computed: {
    ...mapState('Company', ['isReceiving'])
  },
  created () {
    this.initvalue = this.$route.params;
    this.imageurl = this.initvalue.companyimage;
    this.images = this.initvalue.companyimages;
    if(!this.initvalue._id) this.$router.push({ name: 'CompanyList' });
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
